"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    accordionHeaderClassNames: function() {
        return accordionHeaderClassNames;
    },
    useAccordionHeaderStyles_unstable: function() {
        return useAccordionHeaderStyles_unstable;
    }
});
const _react = require("@griffel/react");
const accordionHeaderClassNames = {
    root: 'fui-AccordionHeader',
    button: 'fui-AccordionHeader__button',
    expandIcon: 'fui-AccordionHeader__expandIcon',
    icon: 'fui-AccordionHeader__icon'
};
const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    resetButton: {
        B7ck84d: "f1e4lqlz",
        De3pzq: "f1u2r49w",
        sj55zd: "f1ym3bx4",
        Bahqtrf: "f1mo0ibp",
        Be2twd7: "fjoy568",
        Bg96gwp: "fytdu2e",
        B68tc82: "f1mtd64y",
        Bmxbyg5: "f1y7q3j9",
        z8tnut: "f1g0x7ka",
        z189sj: [
            "fhxju0i",
            "f1cnd47f"
        ],
        Byoj8tv: "f1qch9an",
        uwmqm3: [
            "f1cnd47f",
            "fhxju0i"
        ],
        Bv0vk6g: "f37px4s",
        fsow6f: "fgusgyc"
    },
    focusIndicator: {
        Brovlpu: "ftqa4ok",
        B486eqv: "f2hkw1w",
        B8q5s1w: "f8hki3x",
        Bci5o5g: [
            "f1d2448m",
            "ffh67wi"
        ],
        n8qw10: "f1bjia2o",
        Bdrgwmp: [
            "ffh67wi",
            "f1d2448m"
        ],
        Bb7d1vk: "f226i61",
        zhwhgb: [
            "f13kzufm",
            "fsx75g8"
        ],
        dhy2o1: "flujwa2",
        Gfyso: [
            "fsx75g8",
            "f13kzufm"
        ],
        Bm4h7ae: "f15bsgw9",
        B7ys5i9: "f14e48fq",
        Busjfv9: "f18yb2kv",
        Bhk32uz: "fd6o370",
        Bf4ptjt: "fh1cnn4",
        kclons: [
            "fy7oxxb",
            "f184ne2d"
        ],
        Bhdgwq3: "fpukqih",
        Blkhhs4: [
            "f184ne2d",
            "fy7oxxb"
        ],
        Bqtpl0w: "frrh606",
        clg4pj: [
            "f1v5zibi",
            "fo2hd23"
        ],
        hgwjuy: "ful5kiu",
        Bonggc9: [
            "fo2hd23",
            "f1v5zibi"
        ],
        B1tsrr9: [
            "f1jqcqds",
            "ftffrms"
        ],
        Dah5zi: [
            "ftffrms",
            "f1jqcqds"
        ],
        Bkh64rk: [
            "f2e7qr6",
            "fsr1zz6"
        ],
        qqdqy8: [
            "fsr1zz6",
            "f2e7qr6"
        ],
        B6dhp37: "f1dvezut",
        i03rao: [
            "fd0oaoj",
            "f1cwg4i8"
        ],
        Boxcth7: "fjvm52t",
        Bsom6fd: [
            "f1cwg4i8",
            "fd0oaoj"
        ],
        J0r882: "f57olzd",
        Bule8hv: [
            "f4stah7",
            "fs1por5"
        ],
        Bjwuhne: "f480a47",
        Ghsupd: [
            "fs1por5",
            "f4stah7"
        ]
    },
    root: {
        sj55zd: "f19n0e5",
        De3pzq: "f1c21dwh",
        B6of3ja: "f1hu3pq6",
        t21cq0: [
            "f11qmguv",
            "f1tyq0we"
        ],
        jrapky: "f19f4twv",
        Frg6f3: [
            "f1tyq0we",
            "f11qmguv"
        ],
        Bbmb7ep: [
            "f1aa9q02",
            "f16jpd5f"
        ],
        Beyfa6y: [
            "f16jpd5f",
            "f1aa9q02"
        ],
        B7oj6ja: [
            "f1jar5jt",
            "fyu767a"
        ],
        Btl43ni: [
            "fyu767a",
            "f1jar5jt"
        ]
    },
    rootDisabled: {
        Bcmaq0h: "fwrgwhw",
        sj55zd: "f1s2aq7o"
    },
    rootInline: {
        mc9l5x: "f14t3ns0"
    },
    button: {
        qhf8xq: "f10pi13n",
        a9b677: "fly5x3f",
        B4j52fo: "f5ogflp",
        Bekrc4i: [
            "f1hqa2wf",
            "finvdd3"
        ],
        Bn0qgzm: "f1f09k3d",
        ibv6hh: [
            "finvdd3",
            "f1hqa2wf"
        ],
        icvyot: "fzkkow9",
        vrafjx: [
            "fcdblym",
            "fjik90z"
        ],
        oivjwe: "fg706s2",
        wvpqe5: [
            "fjik90z",
            "fcdblym"
        ],
        g2u3we: "f1p3nwhy",
        h3c5rm: [
            "f11589ue",
            "f1pdflbu"
        ],
        B9xav0g: "f1q5o8ev",
        zhjwy3: [
            "f1pdflbu",
            "f11589ue"
        ],
        z8tnut: "f1g0x7ka",
        z189sj: [
            "fw5db7e",
            "f1uw59to"
        ],
        Byoj8tv: "f1qch9an",
        uwmqm3: [
            "f1ng84yb",
            "f11gcy0p"
        ],
        sshi5w: "f5pgtk9",
        mc9l5x: "f22iagw",
        Bt984gj: "f122n59",
        Bceei9c: "f1k6fduh",
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi",
        B7ck84d: "f1ewtqcl"
    },
    buttonSmall: {
        sshi5w: "f1nxs5xn",
        Be2twd7: "fy9rknc"
    },
    buttonLarge: {
        Bg96gwp: "faaz57k",
        Be2twd7: "fod5ikn"
    },
    buttonExtraLarge: {
        Bg96gwp: "f106mvju",
        Be2twd7: "f1pp30po"
    },
    buttonInline: {
        mc9l5x: "ftuwxu6"
    },
    buttonExpandIconEndNoIcon: {
        uwmqm3: [
            "f1uw59to",
            "fw5db7e"
        ]
    },
    buttonExpandIconEnd: {
        z189sj: [
            "f11gcy0p",
            "f1ng84yb"
        ]
    },
    buttonDisabled: {
        Bceei9c: "fdrzuqr"
    },
    expandIcon: {
        Bqenvij: "f1l02sjl",
        mc9l5x: "f22iagw",
        Bt984gj: "f122n59",
        Bg96gwp: "f106mvju",
        Be2twd7: "f1pp30po"
    },
    expandIconStart: {
        z189sj: [
            "f1vdfbxk",
            "f1f5gg8d"
        ]
    },
    expandIconEnd: {
        Bh6795r: "fqerorx",
        Bnnss6s: "f1neuvcm",
        xawz: "flqd7gy",
        mc9l5x: "f22iagw",
        Brf1p80: "f9c4gz4",
        uwmqm3: [
            "f1f5gg8d",
            "f1vdfbxk"
        ]
    },
    icon: {
        Bqenvij: "f1l02sjl",
        mc9l5x: "f22iagw",
        Bt984gj: "f122n59",
        z189sj: [
            "f1vdfbxk",
            "f1f5gg8d"
        ],
        Bg96gwp: "f106mvju",
        Be2twd7: "f1pp30po"
    }
}, {
    d: [
        ".f1e4lqlz{box-sizing:content-box;}",
        ".f1u2r49w{background-color:inherit;}",
        ".f1ym3bx4{color:inherit;}",
        ".f1mo0ibp{font-family:inherit;}",
        ".fjoy568{font-size:inherit;}",
        ".fytdu2e{line-height:normal;}",
        ".f1mtd64y{overflow-x:visible;}",
        ".f1y7q3j9{overflow-y:visible;}",
        ".f1g0x7ka{padding-top:0;}",
        ".fhxju0i{padding-right:0;}",
        ".f1cnd47f{padding-left:0;}",
        ".f1qch9an{padding-bottom:0;}",
        ".f37px4s{-webkit-appearance:button;}",
        ".fgusgyc{text-align:unset;}",
        ".f8hki3x[data-fui-focus-visible]{border-top-color:transparent;}",
        ".f1d2448m[data-fui-focus-visible]{border-right-color:transparent;}",
        ".ffh67wi[data-fui-focus-visible]{border-left-color:transparent;}",
        ".f1bjia2o[data-fui-focus-visible]{border-bottom-color:transparent;}",
        ".f15bsgw9[data-fui-focus-visible]::after{content:\"\";}",
        ".f14e48fq[data-fui-focus-visible]::after{position:absolute;}",
        ".f18yb2kv[data-fui-focus-visible]::after{pointer-events:none;}",
        ".fd6o370[data-fui-focus-visible]::after{z-index:1;}",
        ".fh1cnn4[data-fui-focus-visible]::after{border-top-style:solid;}",
        ".fy7oxxb[data-fui-focus-visible]::after{border-right-style:solid;}",
        ".f184ne2d[data-fui-focus-visible]::after{border-left-style:solid;}",
        ".fpukqih[data-fui-focus-visible]::after{border-bottom-style:solid;}",
        ".frrh606[data-fui-focus-visible]::after{border-top-width:2px;}",
        ".f1v5zibi[data-fui-focus-visible]::after{border-right-width:2px;}",
        ".fo2hd23[data-fui-focus-visible]::after{border-left-width:2px;}",
        ".ful5kiu[data-fui-focus-visible]::after{border-bottom-width:2px;}",
        ".f1jqcqds[data-fui-focus-visible]::after{border-bottom-right-radius:var(--borderRadiusMedium);}",
        ".ftffrms[data-fui-focus-visible]::after{border-bottom-left-radius:var(--borderRadiusMedium);}",
        ".f2e7qr6[data-fui-focus-visible]::after{border-top-right-radius:var(--borderRadiusMedium);}",
        ".fsr1zz6[data-fui-focus-visible]::after{border-top-left-radius:var(--borderRadiusMedium);}",
        ".f1dvezut[data-fui-focus-visible]::after{border-top-color:var(--colorStrokeFocus2);}",
        ".fd0oaoj[data-fui-focus-visible]::after{border-right-color:var(--colorStrokeFocus2);}",
        ".f1cwg4i8[data-fui-focus-visible]::after{border-left-color:var(--colorStrokeFocus2);}",
        ".fjvm52t[data-fui-focus-visible]::after{border-bottom-color:var(--colorStrokeFocus2);}",
        ".f57olzd[data-fui-focus-visible]::after{top:calc(2px * -1);}",
        ".f4stah7[data-fui-focus-visible]::after{right:calc(2px * -1);}",
        ".fs1por5[data-fui-focus-visible]::after{left:calc(2px * -1);}",
        ".f480a47[data-fui-focus-visible]::after{bottom:calc(2px * -1);}",
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".f1c21dwh{background-color:var(--colorTransparentBackground);}",
        ".f1hu3pq6{margin-top:0;}",
        ".f11qmguv{margin-right:0;}",
        ".f1tyq0we{margin-left:0;}",
        ".f19f4twv{margin-bottom:0;}",
        ".f1aa9q02{border-bottom-right-radius:var(--borderRadiusMedium);}",
        ".f16jpd5f{border-bottom-left-radius:var(--borderRadiusMedium);}",
        ".f1jar5jt{border-top-right-radius:var(--borderRadiusMedium);}",
        ".fyu767a{border-top-left-radius:var(--borderRadiusMedium);}",
        ".fwrgwhw{background-image:none;}",
        ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}",
        ".f14t3ns0{display:inline-block;}",
        ".f10pi13n{position:relative;}",
        ".fly5x3f{width:100%;}",
        ".f5ogflp{border-top-width:1px;}",
        ".f1hqa2wf{border-right-width:1px;}",
        ".finvdd3{border-left-width:1px;}",
        ".f1f09k3d{border-bottom-width:1px;}",
        ".fzkkow9{border-top-style:solid;}",
        ".fcdblym{border-right-style:solid;}",
        ".fjik90z{border-left-style:solid;}",
        ".fg706s2{border-bottom-style:solid;}",
        ".f1p3nwhy{border-top-color:transparent;}",
        ".f11589ue{border-right-color:transparent;}",
        ".f1pdflbu{border-left-color:transparent;}",
        ".f1q5o8ev{border-bottom-color:transparent;}",
        ".fw5db7e{padding-right:var(--spacingHorizontalM);}",
        ".f1uw59to{padding-left:var(--spacingHorizontalM);}",
        ".f1ng84yb{padding-left:var(--spacingHorizontalMNudge);}",
        ".f11gcy0p{padding-right:var(--spacingHorizontalMNudge);}",
        ".f5pgtk9{min-height:44px;}",
        ".f22iagw{display:flex;}",
        ".f122n59{align-items:center;}",
        ".f1k6fduh{cursor:pointer;}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        ".f1ewtqcl{box-sizing:border-box;}",
        ".f1nxs5xn{min-height:32px;}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".faaz57k{line-height:var(--lineHeightBase400);}",
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".f106mvju{line-height:var(--lineHeightBase500);}",
        ".f1pp30po{font-size:var(--fontSizeBase500);}",
        ".ftuwxu6{display:inline-flex;}",
        ".fdrzuqr{cursor:not-allowed;}",
        ".f1l02sjl{height:100%;}",
        ".f1vdfbxk{padding-right:var(--spacingHorizontalS);}",
        ".f1f5gg8d{padding-left:var(--spacingHorizontalS);}",
        ".fqerorx{flex-grow:1;}",
        ".f1neuvcm{flex-shrink:1;}",
        ".flqd7gy{flex-basis:0%;}",
        ".f9c4gz4{justify-content:flex-end;}"
    ],
    f: [
        ".ftqa4ok:focus{outline-style:none;}"
    ],
    i: [
        ".f2hkw1w:focus-visible{outline-style:none;}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f226i61[data-fui-focus-visible]::after{border-top-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f13kzufm[data-fui-focus-visible]::after{border-right-color:Highlight;}.fsx75g8[data-fui-focus-visible]::after{border-left-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.flujwa2[data-fui-focus-visible]::after{border-bottom-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
const useAccordionHeaderStyles_unstable = (state)=>{
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(accordionHeaderClassNames.root, styles.root, state.inline && styles.rootInline, state.disabled && styles.rootDisabled, state.root.className);
    state.button.className = (0, _react.mergeClasses)(accordionHeaderClassNames.button, styles.resetButton, styles.button, styles.focusIndicator, state.expandIconPosition === 'end' && !state.icon && styles.buttonExpandIconEndNoIcon, state.expandIconPosition === 'end' && styles.buttonExpandIconEnd, state.inline && styles.buttonInline, state.size === 'small' && styles.buttonSmall, state.size === 'large' && styles.buttonLarge, state.size === 'extra-large' && styles.buttonExtraLarge, state.disabled && styles.buttonDisabled, state.button.className);
    if (state.expandIcon) {
        state.expandIcon.className = (0, _react.mergeClasses)(accordionHeaderClassNames.expandIcon, styles.expandIcon, state.expandIconPosition === 'start' && styles.expandIconStart, state.expandIconPosition === 'end' && styles.expandIconEnd, state.expandIcon.className);
    }
    if (state.icon) {
        state.icon.className = (0, _react.mergeClasses)(accordionHeaderClassNames.icon, styles.icon, state.icon.className);
    }
    return state;
}; //# sourceMappingURL=useAccordionHeaderStyles.styles.js.map
